/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M17.4697 1.4697a.75.75 0 0 0-1.0607 1.0606L21.8787 8l-5.4697 5.4697a.75.75 0 0 0 1.0607 1.0606L24 8l-6.5303-6.5303Z"
    />
    <path
      fill="currentColor"
      d="M15.2601 6.5c0-.4138-.3364-.7492-.75-.75h-12.26l-.2168.0102a2.239 2.239 0 0 0-1.1666.465 2.2487 2.2487 0 0 0-.8439 1.4531A2.2624 2.2624 0 0 0 0 7.9999v12l.0103.2167c.0418.4376.209.8385.465 1.1666a2.2488 2.2488 0 0 0 1.6903.8652c.028.001.0561.0015.0844.0015l18.2601.0001.2167-.0103a2.2382 2.2382 0 0 0 1.1666-.4651 2.2484 2.2484 0 0 0 .8652-1.6902c.001-.028.0015-.0561.0015-.0844v-3l-.0121-.1348a.7502.7502 0 0 0-.7379-.6152c-.4137 0-.7492.3364-.75.75v3l-.0121.1348a.746.746 0 0 1-.1765.3625.7486.7486 0 0 1-.5614.2527L2.25 20.7499l-.1348-.012a.748.748 0 0 1-.3625-.1765.7486.7486 0 0 1-.2527-.5615v-12l.012-.1348a.7474.7474 0 0 1 .1766-.3625A.7485.7485 0 0 1 2.25 7.25h12.2601l.1348-.012a.7502.7502 0 0 0 .6152-.738Z"
    />
  </React.Fragment>,
  'Sdk'
);
